// extracted by mini-css-extract-plugin
export default {"imageSize":"About_imageSize__XUQRk","topImage":"About_topImage__PCcyP","heightDivImages":"About_heightDivImages__rxGkU","rotateY":"About_rotateY__Vd3k9","w90":"About_w90__7ALnt"};